import { Action, createAction, handleActions } from 'redux-actions'

export interface ILayerState {
  [key: string]: boolean
}

export const LAYER = 'CommonLayer'

const OPEN = `${LAYER}/OPEN`
const CLOSE = `${LAYER}/CLOSE`

export const layerActions = {
  open: createAction(OPEN),
  close: createAction(CLOSE),
}

const initialState = {}

export const reducer = {
  [OPEN]: (state: ILayerState, action: Action<string>) => ({
    ...state,
    [action.payload]: true,
  }),
  [CLOSE]: (state: ILayerState, action: Action<string>) => ({
    ...state,
    [action.payload]: false,
  }),
}

export const layerReducer = handleActions(reducer, initialState)
